import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-sem-permissao-modal',
  templateUrl: './sem-permissao-modal.component.html',
  styleUrls: ['./sem-permissao-modal.component.scss']
})
export class SemPermissaoModalComponent {
  @Input() isOpen = false;
  @Output() fechado = new EventEmitter<void>();
  @Output() trocarContexto = new EventEmitter<void>();

  onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.fechado.emit();
    }
  }

  onFechar(): void {
    this.fechado.emit();
  }

  onTrocarContexto(): void {
    this.fechado.emit();
    this.trocarContexto.emit();
  }
}
